<template>
    <shield-modal
        :id="'form-congratulations-modal'"
        :size="'lg'"
        @handleSubmit="()=>{}"
        @handleCancel="()=>{}"
        :noClose="false"
        :hideHeaderClose="false"
        >
        <template #title>
            Congratulations!
        </template>
        <template #default>
            <b-container>
                <b-row>
                    <b-col class="d-flex justify-content-center">
                        <p>You've signed all your forms! You'll be able to download them from your Dashboard.</p>
                    </b-col>                    
                </b-row>
                <b-row>
                    <b-col class="d-flex justify-content-center">
                        <ul class="fa-ul">
                            <li v-for="(form, index) in forms" :key="index+'_form'">
                                <span class="fa-li"><i class="fa-solid fa-file"></i></span><p><strong>{{ form.name  }}</strong></p>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="d-flex justify-content-center">
                        <p class="font-dancing-script font-size-2 mb-1">
                            {{legalName}}
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="d-flex justify-content-center">
                        <span>Signed by <strong> {{legalName}} </strong> {{ signDate}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="d-flex justify-content-center">
                        <div>
                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.5 6.10984e-05L8.84375 0.156311L15.3438 2.65631L15.9375 2.90631L15.9688 3.53131C16.0625 5.09381 15.8125 7.50006 14.8125 9.81256C13.7813 12.1563 11.9688 14.5001 8.875 15.8438L8.5 16.0001L8.09375 15.8438C5 14.5001 3.1875 12.1876 2.15625 9.81256C1.15625 7.50006 0.90625 5.09381 1 3.53131L1.03125 2.90631L1.625 2.65631L8.125 0.156311L8.5 6.10984e-05ZM12.0313 6.53131L12.5625 6.00006L11.5 4.96881L10.9688 5.50006L7.5 8.96881L6.03125 7.50006L5.5 6.96881L4.4375 8.00006L4.96875 8.53131L6.96875 10.5313L7.5 11.0626L8.03125 10.5313L12.0313 6.53131Z" fill="#71777D"/>
                            </svg>
                            <span><i>Verified by Sellers Shield&trade;</i>&nbsp;ID:&nbsp;{{primarySeller?.uuid}}</span>
                        </div>
                    </b-col>
                </b-row>
            </b-container>           
        </template>
    </shield-modal>
</template>
<script>
import './FormCongratulations.scss';
import ShieldModal from "@components/modals/ShieldModal/ShieldModal.vue"
import {useOrdersStore} from '@store';
import {primarySeller, orderForms} from '@helpers/order';
import {mapState, mapActions} from 'pinia';
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
export default {
    name:'FormCongratulations',
    props:{
        orderUuid:{
            type: String,
            required: true
        }
    },
    data:()=>({
        include:[
            'sellers',
            'sellers.user',
            'disclosure',
            'disclosure.jotFormDisclosureSessions',
            'disclosure.jotFormDisclosureSessions.files',
            'disclosure.jotFormDisclosureSessions.form',
            'disclosure.jotFormDisclosureSessions.form.parentForm',
            'disclosure.jotFormDisclosureSessions.form.sections',
            'invitation',
            'forms',
            'forms.sections',
            'forms.parentForm'
        ],
        orderAppResource: null
    }),
    components:{
        ShieldModal
    },
    computed:{
        ...mapState(useOrdersStore, {
            getOrder: 'getSelectedOrder',
            getOrders: 'getAllAssociatedOrders'
        }),
        selectedOrder(){
            return this.orderAppResource;
        },
        disclosure(){
            return this.selectedOrder?.disclosure
        },
        forms(){
            return this.selectedOrder?.forms ? orderForms(this.selectedOrder) : [];
        },
        meta(){
            return this.disclosure ? this.disclosure?.meta : null;
        },
        legalName(){
            return this.meta?.signatures?.primaryName;
        },
        signDate(){
            return (this.meta?.primaryTimestamp ? 
                new Date((this.meta?.primaryTimestamp) * 1000) : 
                new Date(Date.now())).toLocaleString('en-US', {timeZoneName: 'short'});
        },
        primarySeller(){
            return this.selectedOrder ? primarySeller(this.selectedOrder) : null;
        }
    },
    methods:{
        ...mapActions(useOrdersStore, {
            fetchOrder: 'fetchOrderUsingUuid',
            setOrder: 'setSelectedOrderDetailsByUuid'
        }),
    },
    async mounted(){
        this.orderAppResource = new OrderAppResource({
            uuid: this.orderUuid
        });
        await this.orderAppResource.find(this.include);
    }
}
</script>
